import React from 'react';
import { Auth as AuthSetup } from 'architecture'
//import Amplify from 'aws-amplify';
//import config from './aws-exports'
import Auth from '@aws-amplify/auth'
//import { Auth } from 'aws-amplify';

const Authenticator = AuthSetup(null, Auth)

export default (props) => {
  return (
    <div>
    { props.auth && props.signIn ?
      <div className='mw6 center' >
        <Authenticator {...props} />
      </div>
      :
      null
    }
    </div>
  )
}